import React, { useContext, useEffect } from "react";
import "./PaymentsCreditHistory.scss";
import TimeCell from "../../utilities/TimeCell";
import { PaymentsCreditsContextProvider } from "./PaymentsCreditsContext";
import ReactDataTable from "../Common/ReactDataTable";
import SkeletonEmptyDialogue from "../SkeletonComponents/SkeletonEmptyDialogue";

const transactionColumnList = [
  {
    accessor: "decentro_urn",
    name: "Decentro URN",
    showInitial: true,
  },
  {
    accessor: "api_name",
    name: "API Name",
    showInitial: true,
  },
  { accessor: "module_name", name: "Module Name", showInitial: true },
  {
    accessor: "timestamp",
    name: "Timestamp",
    type: "date",
    showInitial: true,
    cell: TimeCell,
  },
  { accessor: "credits", name: "Credits", showInitial: true },
];

const PaymentsCreditsReactTable = () => {
  const {
    isError,
    errorResponse,
    tableData,
    totalCount,
    filterList,
    fetchData,
    firstApiCall,
  } = useContext(PaymentsCreditsContextProvider);
  useEffect(() => {
    if (tableData.length >= totalCount && tableData.length !== 0) return;
    const prefetchLimit = 200;
    const endIndex = filterList.currentPage * filterList.resultsPerPage;
    const limitConstant =
      Math.ceil((endIndex + 1) / prefetchLimit) * prefetchLimit +
      2 * filterList?.resultsPerPage;
    if (totalCount > 0) {
      if (tableData.length < limitConstant && firstApiCall === false) {
        fetchData(tableData.length + 1, undefined, undefined, undefined, false);
      }
    } else if (
      totalCount === 0 &&
      tableData.length === 0 &&
      firstApiCall === true
    ) {
      fetchData(tableData.length + 1, undefined, undefined, undefined, false);
    }
  }, [filterList.currentPage]);
  return (
    <>
      {!isError ? (
        <ReactDataTable
          tableTitle={"Credit History"}
          provider={PaymentsCreditsContextProvider}
          isModalPresent={false}
          columnList={transactionColumnList}
          showDownloadBtn={false}
        />
      ) : (
        <SkeletonEmptyDialogue type={errorResponse} />
      )}
    </>
  );
};

export default PaymentsCreditsReactTable;
